import { Injectable } from "@angular/core";
import { Headers, Http } from "@angular/http";
import {
    BASE_URLS,
    ITCIApplicationOwner,
    ITCIApplicationTenancyRequest,
    TCIApplicationTenancyAction
} from "@tci/common";
import { Observable } from "rxjs";

@Injectable()
export class NgApplicationTenancyService {

    constructor(
        private http: Http
    ) { }

    public transferOwnership(appId: string, newAppOwner: ITCIApplicationOwner): Observable<any> {
        const payload: ITCIApplicationTenancyRequest = {
            tenantAction: TCIApplicationTenancyAction.TENANT_TRANSFER_OWNERSHIP,
            appId: appId,
            tenantOwner: newAppOwner
        };
        return this.sendRequest(payload);
    }
    public copyApplication(srcAppId: string, targetSbscId: string): Observable<any> {
        const payload: ITCIApplicationTenancyRequest = {
            tenantAction: TCIApplicationTenancyAction.TENANT_COPY_APPLICATION,
            appId: srcAppId,
            targetSbscId: targetSbscId
        };
        return this.sendRequest(payload);
    }

    /*
    public renameApplication(appId: string, newApplicationName: string): Observable<any> {
        const payload: ITCIApplicationTenancyRequest = {
            tenantAction: TCIApplicationTenancyAction.TENANT_RENAME_APPLICATION,
            appId: appId,
            newApplicationName: newApplicationName
        };
        return this.sendRequest(payload);
    }

    public changeEndpointVisibility(appId: string, visibility: string): Observable<any> {
        const payload: ITCIApplicationTenancyRequest = {
            tenantAction: TCIApplicationTenancyAction.TENANT_ENDPOINT_VISIBILITY,
            appId: appId,
            endpointVisibility: visibility
        };
        return this.sendRequest(payload);
    }
    */

    private sendRequest(payload: ITCIApplicationTenancyRequest) {
        // TODO: complete the url
        const url = `${BASE_URLS.WEBSERVER}/apps/`;

        return this
            .http
            .post(url, payload, {
                headers: new Headers({
                    "Content-Type": "application/json"
                })
            })
            .map(res => res && res.json() || null);
    }
}
